enum Flags {
  WEB_WIZARD_READ = "WEB_WIZARD_READ",
  PUBLIC_LEADERBOARD_OPT_OUT = "PUBLIC_LEADERBOARD_OPT_OUT",
  PUBLIC_LEADERBOARD_OPT_IN = "PUBLIC_LEADERBOARD_OPT_IN",
  PUBLIC_LEADERBOARD_OPT_IN_PSEUDONYM = "PUBLIC_LEADERBOARD_OPT_IN_PSEUDONYM",
  BOOTCAMP_FINISHED_DIALOG_READ = "BOOTCAMP_FINISHED_DIALOG_READ",
  BOOTCAMP_WELCOME_READ = "BOOTCAMP_WELCOME_READ",
  TRAINING_PLANS_ONBOARDING_READ = "TRAINING_PLANS_ONBOARDING_READ",
}

export default Flags;
